import { ClientPicker } from '../../../components/clients/ClientPicker';
import { PillButton } from '../../../components/clients/PillButton';
import type { ClientEntity } from '../../../lib/clients-api';

interface Step1ClientProps {
  value: ClientEntity | null;
  onChange: (client: ClientEntity | null) => void;
  onCreateNew: () => void;
  onNext: () => void;
  onCancel: () => void;
}

export function Step1Client({
  value,
  onChange,
  onCreateNew,
  onNext,
  onCancel,
}: Step1ClientProps): JSX.Element {
  const canAdvance = Boolean(value);

  return (
    <div className="space-y-5">
      <div className="space-y-1">
        <h2 className="m-0 text-[15px] font-semibold text-ink">Quem é o cliente?</h2>
        <p className="text-[12px] text-muted">
          Busque por nome ou documento. Se o cliente não existe, crie agora sem perder o progresso.
        </p>
      </div>

      <ClientPicker value={value} onChange={onChange} onCreateNew={onCreateNew} />

      <div className="flex items-center justify-end gap-2 border-t border-line pt-4">
        <PillButton type="button" onClick={onCancel}>
          Cancelar
        </PillButton>
        <PillButton solid type="button" onClick={onNext} disabled={!canAdvance}>
          Avançar →
        </PillButton>
      </div>
    </div>
  );
}
